import { GameStates } from "onearm";
import { services } from "onearm";

import { SubGameState } from "./SubGameState";

export class Restore extends SubGameState {
    enter() {
        this.restore();
    }

    async restore() {
        if (this.gameLogic.hasFreeSpins()) {
            this.gameState.goTo(GameStates.FREE_SPIN_INTRO);
            return;
        } else {
            // this.gameState.playMainMusic();
        }

        this.gameState.goTo(GameStates.IDLE);
    }
}
